module.exports = __webpack_public_path__ + "media/application/images/icons/icon-heart-ee62ac25468d52af22467abfc8276a52.svg";